// extracted by mini-css-extract-plugin
export default {"fixedHeightColumn":"_7cEcO"};